import { render, staticRenderFns } from "./AddTraining.vue?vue&type=template&id=52940e47&"
import script from "./AddTraining.vue?vue&type=script&lang=js&"
export * from "./AddTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports